{
  "title": "Transferts",
  "subtitle": "Déplacez du stock entre vos emplacements. Le côté qui reçoit confirme ce qui est vraiment arrivé.",
  "new": "Nouveau transfert",
  "export": "Exporter vers Excel",
  "how": {
    "send": {
      "title": "Envoyer",
      "text": "Le stock quitte la source et attend « En transit »."
    },
    "receive": {
      "title": "Recevoir",
      "text": "La destination saisit ce qui est arrivé. Ce qui manque peut encore venir, ou être clôturé comme perte en transit."
    },
    "oneStep": {
      "title": "En une étape",
      "text": "Entre endroits d'un même site, ou avec le droit de transfert rapide : envoyé et reçu d'un coup."
    }
  },
  "tabs": {
    "in_transit": "En transit",
    "drafts": "Brouillons",
    "received": "Reçus",
    "all": "Tous"
  },
  "status": {
    "draft": "Brouillon",
    "sent": "Envoyé",
    "partially_received": "Reçu en partie",
    "received": "Reçu",
    "cancelled": "Annulé",
    "direct": "Fait en une étape"
  },
  "mode": {
    "two_step": "Deux étapes",
    "direct": "Une étape",
    "sameSite": "Même site : {{name}}"
  },
  "columns": {
    "number": "Numéro",
    "fromTo": "De → Vers",
    "lines": "Lignes",
    "sent": "Envoyé",
    "onTheWay": "En route depuis",
    "status": "Statut",
    "action": "Action",
    "product": "Produit"
  },
  "age": {
    "hours_one": "{{count}} heure",
    "hours_many": "{{count}} heures",
    "hours_other": "{{count}} heures",
    "days_one": "{{count}} jour",
    "days_many": "{{count}} jours",
    "days_other": "{{count}} jours"
  },
  "list": {
    "search": "Numéro de transfert",
    "receive": "Recevoir",
    "continue": "Continuer",
    "notSent": "Pas encore envoyé",
    "sentOn": "envoyé {{date}}",
    "receivedOn": "Reçu {{date}}",
    "late": "{{age}} · en retard",
    "lateRule_one": "Les transferts non reçus après {{count}} jour sont signalés",
    "lateRule_many": "Les transferts non reçus après {{count}} jours sont signalés",
    "lateRule_other": "Les transferts non reçus après {{count}} jours sont signalés",
    "lateCount_one": "{{count}} en retard",
    "lateCount_many": "{{count}} en retard",
    "lateCount_other": "{{count}} en retard",
    "lines_one": "{{count}} ligne",
    "lines_many": "{{count}} lignes",
    "lines_other": "{{count}} lignes",
    "showing_one": "{{count}} transfert affiché",
    "showing_many": "{{count}} transferts affichés",
    "showing_other": "{{count}} transferts affichés",
    "loadMore": "Afficher plus"
  },
  "empty": {
    "in_transit": "Rien en route",
    "drafts": "Aucun brouillon",
    "received": "Aucun transfert reçu pour l'instant",
    "all": "Aucun transfert pour l'instant",
    "text": "Déplacez du stock entre deux endroits avec Nouveau transfert."
  },
  "route": {
    "from": "De",
    "to": "Vers",
    "inTransit": "En transit",
    "oneStep": "Une étape",
    "sentBy": "Envoyé par {{name}}"
  },
  "editor": {
    "new": "Nouveau",
    "title": "Déplacer du stock",
    "saving": "Enregistrement…",
    "saved": "Enregistré automatiquement à {{time}} · le stock n'a pas encore bougé",
    "notSaved": "Enregistré automatiquement dès que vous ajoutez un produit",
    "where": "D'où vers où",
    "from": "Depuis l'emplacement",
    "to": "Vers l'emplacement",
    "choose": "Choisir…",
    "date": "Date",
    "note": "Note",
    "sameSite": "Les deux endroits sont dans {{name}} : le stock bouge en une étape, sans « En transit ».",
    "quick": "Le déplacer en une étape",
    "quickText": "Envoyé et reçu d'un coup, sans « En transit ». À utiliser quand le stock est déjà sur place.",
    "lines_one": "Produits à déplacer · {{count}} ligne",
    "lines_many": "Produits à déplacer · {{count}} lignes",
    "lines_other": "Produits à déplacer · {{count}} lignes",
    "scannerReady": "Scanner prêt",
    "product": "Produit",
    "available": "Disponible",
    "quantity": "Quantité",
    "removeLine": "Retirer la ligne",
    "noLines": "Aucun produit pour l'instant : scannez un code-barres ou tapez un nom ci-dessus.",
    "summary": "Résumé",
    "linesLabel": "Lignes",
    "value": "Valeur",
    "explainTwoSteps": "À l'envoi, le stock quitte la source et attend « En transit » jusqu'à sa réception par la destination.",
    "explainDirect": "Au déplacement, le stock quitte la source et entre dans la destination d'un coup.",
    "send": "Envoyer",
    "moveNow": "Déplacer maintenant",
    "cannotSend": "Votre rôle prépare les transferts ; une personne autorisée à envoyer les terminera.",
    "keepDraft": "Garder en brouillon",
    "discard": "Abandonner le brouillon",
    "discardTitle": "Abandonner ce transfert ?",
    "discardText": "Rien n'a bougé. Le brouillon garde son numéro et apparaît comme Annulé.",
    "discarded": "Transfert abandonné",
    "sent": "{{number}} envoyé : il est maintenant en transit",
    "moved": "{{number}} déplacé",
    "fixIssues": "Il manque des informations : voir les champs en rouge",
    "atDestination": "À destination",
    "limits": "Min {{min}} · max {{max}}",
    "fillToMax": "Compléter jusqu'au max : {{quantity}}",
    "fillToMaxHint": "Amène la destination à son maximum, sans dépasser ce qu'a la source."
  },
  "receive": {
    "title": "Recevoir le transfert",
    "receivedBy": "Reçu par vous, {{name}}",
    "what": "Qu'est-ce qui est arrivé ?",
    "whatHint": "Comptez les cartons, puis saisissez ce que vous avez vraiment.",
    "everything": "Tout est arrivé comme envoyé",
    "before": "Reçu avant",
    "now": "Reçu maintenant",
    "missing": "Manque encore",
    "complete": "Complet",
    "receivedBefore": "Reçu avant",
    "missingShort": "{{quantity}} manquant(s)",
    "missingOne": "{{quantity}} {{unit}} de {{name}} manquent. Que faire ?",
    "missingMany_one": "{{count}} produit n'est pas complet. Que faire ?",
    "missingMany_many": "{{count}} produits ne sont pas complets. Que faire ?",
    "missingMany_other": "{{count}} produits ne sont pas complets. Que faire ?",
    "choose": "Choisissez. Vous pouvez encore changer d'avis avant de confirmer.",
    "more": "La suite va arriver",
    "moreText": "Le transfert reste « Reçu en partie ». Ce qui manque reste en transit jusqu'à son arrivée.",
    "close": "Clôturer avec un écart",
    "closeText": "Ce qui manque est enregistré comme ajustement « Perte en transit » et le transfert est clôturé.",
    "closeTextValue": "Ce qui manque est enregistré comme ajustement « Perte en transit » ({{value}} TND) et le transfert est clôturé.",
    "allThere": "Tout ce qui a été envoyé est là.",
    "note": "Note (facultatif)",
    "notNow": "Pas maintenant",
    "confirm": "Confirmer la réception",
    "confirmOpen": "Confirmer · garder le transfert ouvert",
    "confirmClose": "Confirmer · clôturer le transfert",
    "done": "{{number}} reçu",
    "partly": "{{number}} reçu en partie : le reste est encore en route",
    "enterFirst": "Saisissez ce qui est arrivé, ou utilisez « Tout est arrivé comme envoyé ». Tapez 0 pour un produit qui n’est pas venu."
  },
  "detail": {
    "title": "Transfert",
    "mode": "Mode",
    "received": "Reçu",
    "lost": "Perdu en route",
    "lines": "Produits",
    "receipts": "Réceptions",
    "receiptLine_one": "{{count}} produit reçu par {{name}}",
    "receiptLine_many": "{{count}} produits reçus par {{name}}",
    "receiptLine_other": "{{count}} produits reçus par {{name}}",
    "closedShort": "Clôturé avec un écart",
    "lossTitle": "Clôturé avec un écart",
    "loss": "Perte en transit : {{number}}",
    "lossValue": "Perte en transit : {{number}} · {{value}} TND",
    "cancelled": "Abandonné {{when}} par {{name}}. Rien n’a bougé."
  }
}
